export default {
  init() {
    this.links = document.querySelectorAll('.accessible-link');
    this.eventListener();
  },
  eventListener() {
    const events = ['click', 'keydown'];
    this.links.forEach((link) => {
      events.forEach((event) => {
        link.addEventListener(event, (e) => this.navigateToLink(e));
      });
    });
  },
  navigateToLink(event) {
    if (event.type === 'click' || event.keyCode === 13) {
      const link = event.currentTarget != null ? event.currentTarget : event.srcElement;
      if (link) {
        window.location.href = link.dataset.href;
      }
    }
  },
};
